export default __webpack_public_path__ + "images/8c05468fc876c1866ee0b9fb35594131-judaism_small.webp";